// ------------------------------------ single product tab ----------------------------//

 jQuery(document).ready(function () {

    jQuery('.tab').on('click', function () {
      var target = jQuery(this).data('tab');
      jQuery('.tab').removeClass('active');
      jQuery(this).addClass('active');
      jQuery('.tab-content').removeClass('active');
      jQuery('#' + target).addClass('active');
    });

  
    jQuery('.accordion-header').on('click', function () {
      var parent = jQuery(this).parent();

      if (parent.hasClass('active')) {
        parent.removeClass('active');
        jQuery(this).find('.icon').text('+');
        jQuery(this).next('.accordion-body').slideUp(300);
      } else {
        jQuery('.accordion-item').removeClass('active');
        jQuery('.accordion-item .icon').text('+');
        jQuery('.accordion-body').slideUp(300);

        parent.addClass('active');
        jQuery(this).find('.icon').text('−');
        jQuery(this).next('.accordion-body').slideDown(300);
      }
    });
  });

// ------------------------ review slider -----------------------------//
 const reviewSlider = new Swiper('.reviews-slider', {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: true,
    centeredSlides: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        centeredSlides: false,
      },
      576: {
        slidesPerView: 2,
        centeredSlides: false,
      },
      768: {
        slidesPerView: 3,
         centeredSlides: false,
      },
      1024: {
        slidesPerView: 4,
      },
    },
  });
// ------------------------ review slider -----------------------------//


//-------------------------new spotlight slider ---------------------------//

// Initialize the new spotlight slider
const spotlightSlider = new Swiper(".new-spotlight-slider.swiper ", {
  effect: "coverflow",
  centeredSlides: true,
  loop: true,
  loopAdditionalSlides: 2,
  spaceBetween: 30,
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 100,
    modifier: 3.1,
    slideShadows: false,
  },
  // autoplay: {
  //   delay: 3000,
  //   disableOnInteraction: false,
  // },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    600: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
  },
  on: {
    slideChange: function () {
      // Pause the video of the previous slide when slide changes
      const previousSlide = this.slides[this.previousIndex];
      const previousVideo = previousSlide.querySelector("video");
      if (previousVideo) {
        previousVideo.pause();
        previousVideo.currentTime = 0;
      }

      // Get the video in the new active slide and start playing it
      const activeSlide = this.slides[this.activeIndex];
      const activeVideo = activeSlide.querySelector("video");
      if (activeVideo) {
        activeVideo.play();
        // Listen for the video end event to change the slide
        activeVideo.addEventListener("ended", () => {
          this.slideNext(); // Move to the next slide after video ends
        });
      }
    },
  },
});

// Pause autoplay on hover, resume on leave
const spotlightSliderContainer = document.querySelector(".new-spotlight-slider");

if (spotlightSliderContainer) {
  spotlightSliderContainer.addEventListener("mouseenter", () => {
    spotlightSlider.autoplay.stop();
  });

  spotlightSliderContainer.addEventListener("mouseleave", () => {
    spotlightSlider.autoplay.start();
  });
}

// Autoplay video of the first slide when page loads
document.addEventListener("DOMContentLoaded", function () {
  const firstSlide = spotlightSlider.slides[spotlightSlider.activeIndex];
  const firstVideo = firstSlide.querySelector("video");
  if (firstVideo) {
    firstVideo.play();
    // Listen for the video end event to change the slide after the first video ends
    firstVideo.addEventListener("ended", () => {
      spotlightSlider.slideNext(); // Move to the next slide after first video ends
    });
  }
});


// // Autoplay video of the first slide when page loads (SAFE)
// document.addEventListener("DOMContentLoaded", function () {
//   // spotlightSlider must exist and have slides
//   if (
//     typeof spotlightSlider === "undefined" ||
//     !spotlightSlider ||
//     !spotlightSlider.slides ||
//     !spotlightSlider.slides.length
//   ) {
//     return;
//   }

//   const firstSlide = spotlightSlider.slides[spotlightSlider.activeIndex];
//   if (!firstSlide) return;

//   const firstVideo = firstSlide.querySelector("video");
//   if (!firstVideo) return;

//   // Try autoplay (may be blocked if not muted)
//   const playPromise = firstVideo.play();
//   if (playPromise && typeof playPromise.catch === "function") {
//     playPromise.catch(() => {});
//   }

//   // When video ends -> go next
//   firstVideo.addEventListener("ended", () => {
//     if (spotlightSlider && typeof spotlightSlider.slideNext === "function") {
//       spotlightSlider.slideNext();
//     }
//   });
// });

// ------------------------- New Spotlight Slider --------------------------- //

//-------------------------spotlight slider ---------------------------//

const swiper = new Swiper(".spotlight-slider", {
  effect: "coverflow",
  centeredSlides: true,
  loop: true,
  loopAdditionalSlides: 2, 
  spaceBetween: 30,
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 100,
    modifier: 3.1,
    slideShadows: false,
  },
  // autoplay: {
  //   delay: 3000,
  //   disableOnInteraction: false,
  // },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    600: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
  },
// });


// // ✅ Pause autoplay on hover, resume on leave
// const swiperContainer = document.querySelector(".spotlight-slider");

// if (swiperContainer) {
//   swiperContainer.addEventListener("mouseenter", () => {
//     swiper.autoplay.stop();
//   });

//   swiperContainer.addEventListener("mouseleave", () => {
//     swiper.autoplay.start();
//   });
// }
  on: {
    slideChange: function () {
      // Pause the video of the previous slide when slide changes
      const previousSlide = this.slides[this.previousIndex];
      const previousVideo = previousSlide.querySelector("video");
      if (previousVideo) {
        previousVideo.pause();
        previousVideo.currentTime = 0; // Reset video playback
      }

      // Get the video in the new active slide and start playing it
      const activeSlide = this.slides[this.activeIndex];
      const activeVideo = activeSlide.querySelector("video");
      if (activeVideo) {
        activeVideo.play();
        // Listen for the video end event to change the slide
        activeVideo.addEventListener("ended", () => {
          this.slideNext(); // Automatically move to next slide after video ends
        });
      }
    },
  },
});

// ✅ Pause autoplay on hover, resume on leave
const swiperContainer = document.querySelector(".spotlight-slider");

if (swiperContainer) {
  swiperContainer.addEventListener("mouseenter", () => {
    swiper.autoplay.stop();
  });

  swiperContainer.addEventListener("mouseleave", () => {
    swiper.autoplay.start();
  });
}
//-------------------------spotlight slider ---------------------------//
window.onload = function () {
  var wishlistDiv = document.querySelector('[data-block-handle="product_wishlist"]');
  var wishlistUL = wishlistDiv?.nextElementSibling;

  if (
    wishlistDiv &&
    wishlistUL &&
    wishlistUL.classList.contains("icon-with-text")
  ) {
    var wrapper = document.createElement("div");
    wrapper.className = "wwici__wishlist_notice";

    // Insert wrapper before wishlistDiv
    wishlistDiv.parentNode.insertBefore(wrapper, wishlistDiv);

    // Move both wishlistDiv and wishlistUL inside the wrapper
    wrapper.appendChild(wishlistDiv);
    wrapper.appendChild(wishlistUL);
  }
};

// --------------------------------- Wrap the review and iconbox section on home page----------------------//
document.addEventListener("DOMContentLoaded", function () {
  const carouselSection = document.querySelector(".template-index section:has(.jdgm-carousel-wrapper)");
  const statsSection = document.querySelector(".template-index section:has(.stats-wrapper)");

  if (carouselSection && statsSection) {
    // Create the wrapper
    const wrapper = document.createElement("div");
    wrapper.className = "unified-bg-wrapper";

    // Insert wrapper before the first section
    carouselSection.parentNode.insertBefore(wrapper, carouselSection);

    // Move both sections into the wrapper
    wrapper.appendChild(carouselSection);
    wrapper.appendChild(statsSection);
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const carouselSection2 = document.querySelector(".template-product section:has(.bamboo-fabric-section)");
  const statsSection2 = document.querySelector(".template-product section:has(.stats-wrapper)");

  if (carouselSection2 && statsSection2) {
    // Create the wrapper
    const wrapper2 = document.createElement("div");
    wrapper2.className = "unified-bg-wrapper";

    // Insert wrapper2 before the first section
    carouselSection2.parentNode.insertBefore(wrapper2, carouselSection2);

    // Move both sections into the wrapper2
    wrapper2.appendChild(carouselSection2);
    wrapper2.appendChild(statsSection2);
  }
});

// --------------------------------- Change the placholder for search input on mobile----------------------//

function updatePlaceholder() {
  const input = document.querySelector('.wwici-search-input');
  if (input) {
    if (window.innerWidth < 589) {
      input.placeholder = "Search";
    } else {
      input.placeholder = "Search for products, categories...";
    }
  }
}

// Run once when DOM is loaded
window.addEventListener('DOMContentLoaded', updatePlaceholder);

// Run on window resize
window.addEventListener('resize', updatePlaceholder);


// ------------------------------------------- Add Main Collection Class to Menu ------------------------------------------//

window.onload = function () {
  setTimeout(function () {
    const uls = document.querySelectorAll('ul.huk_menu_submenu');
    uls.forEach(ul => {
      if (ul.querySelector('.li-main-collection')) {
        ul.classList.add('has-main-collection');
      }
    });
  }, 1000); // 1 second delay
};
// Popup

// ------------------------------------------- Add shipping details to the cart drawer ------------------------------------------//



(function () {
  const NOTE_ID = "corner-preorder-note";
  const NOTE_HTML = `
    <div id="${NOTE_ID}" class="preorder-checkout-note" data-preorder-note="1">
      ⏳ Your cart includes a pre-order item.
      Estimated dispatch: <strong>6–8 weeks</strong>.
    </div>
  `;

  let lastState = null;
  let t = null;

  function ensureCSS() {
    if (document.getElementById("preorder-note-css")) return;
    const s = document.createElement("style");
    s.id = "preorder-note-css";
    s.textContent = `
      /* Note inside scroll card */
      .preorder-checkout-note{
        margin: 14px 16px 18px;
        padding: 10px 12px;
        border-radius: 10px;
        border: 1px solid #d1d1d1;
        background: #e9e9e9;
        color: #000000;
        font-size: 13px;
        line-height: 18px;
        font-weight: 500;
      }
      .preorder-checkout-note strong{font-weight:700;}
    `;
    document.head.appendChild(s);
  }

  // ✅ NEW: insert at bottom inside the cart item list card
  function getAnchor() {
    // this exists inside the scrollable card
    return document.getElementById("corner-cowi-cart-item-list-card-inner-elements-wrapper")
      || document.getElementById("corner-cowi-cart-item-list-card");
  }

  function ensureInserted() {
    const anchor = getAnchor();
    if (!anchor) return false;

    // already exists? do nothing
    if (document.getElementById(NOTE_ID)) return true;

    anchor.insertAdjacentHTML("beforeend", NOTE_HTML);
    return true;
  }

  function removeNote() {
    const el = document.getElementById(NOTE_ID);
    if (el) el.remove();
  }

  async function hasPreorderFromCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin", cache: "no-store" });
    if (!res.ok) return false;
    const cart = await res.json();
    const items = cart?.items || [];
    return items.some(it => {
      const props = it?.properties || {};
      return props && (props._preorder === "true" || props._preorder === true);
    });
  }

  async function update() {
    ensureCSS();

    // run only when Corner cart drawer exists
    if (!document.getElementById("corner-cowi-cart-wrapper")) return;

    const has = await hasPreorderFromCart();
    if (has === lastState) return;
    lastState = has;

    if (has) ensureInserted();
    else removeNote();
  }

  function scheduleUpdate(delay = 180) {
    clearTimeout(t);
    t = setTimeout(update, delay);
  }

  // ✅ instant insert on preorder add-to-cart submit
  document.addEventListener("submit", function (e) {
    const form = e.target;
    if (!form || !form.matches('form[action^="/cart/add"]')) return;

    const preorderInput = form.querySelector('input[name="properties[_preorder]"][value="true"]');
    if (preorderInput) {
      let tries = 0;
      const iv = setInterval(() => {
        tries++;
        const inserted = ensureInserted();
        if (inserted || tries > 25) clearInterval(iv);
      }, 80);
    }
    scheduleUpdate(350);
  }, true);

  // observe drawer changes
  new MutationObserver(() => scheduleUpdate(180))
    .observe(document.body, { childList: true, subtree: true });

  document.addEventListener("DOMContentLoaded", () => scheduleUpdate(200));
  window.addEventListener("load", () => scheduleUpdate(200));
})();

